/* ==========================================================================
   Constant Contact pop-up — the two bits CSS can't do

   The design reference calls for placeholder text in the fields (instead of
   labels above them) and a "No thanks" dismiss link under the button. The
   Constant Contact widget emits neither, and CSS can't add a real placeholder
   attribute or a clickable control, so they're added here.

   Everything else about the pop-up's appearance lives in
   constant-contact-popup.css.
   ========================================================================== */

(function () {
  'use strict';

  var PLACEHOLDERS = {
    first_name: 'First name',
    email_address: 'Email address',
    custom_field_string_birth_date: 'Birthday — MM/DD (optional)'
  };

  var DISMISS_TEXT = 'No thanks, I’ll just browse';

  function decorate(form) {
    if (form.dataset.mbPopupReady) return;
    form.dataset.mbPopupReady = 'true';

    Object.keys(PLACEHOLDERS).forEach(function (name) {
      var input = form.querySelector('input[name="' + name + '"]');
      if (input && !input.getAttribute('placeholder')) {
        input.setAttribute('placeholder', PLACEHOLDERS[name]);
      }
    });

    var submit = form.querySelector('.ctct-form-button');
    if (!submit || form.querySelector('.mb-popup-dismiss')) return;

    var dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.className = 'mb-popup-dismiss';
    dismiss.textContent = DISMISS_TEXT;
    dismiss.addEventListener('click', function () {
      // Reuse the widget's own close button so it records the dismissal and
      // sets its cookie, rather than just hiding the element.
      var close = document.querySelector('.ctct-popup-close');
      if (close) close.click();
    });

    submit.insertAdjacentElement('afterend', dismiss);
  }

  function scan() {
    var forms = document.querySelectorAll('.ctct-form-popup .ctct-form-custom');
    Array.prototype.forEach.call(forms, decorate);
    return forms.length > 0;
  }

  function start() {
    if (scan()) return;

    // The widget script is async, so the form usually lands after this runs.
    var observer = new MutationObserver(function () {
      if (scan()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
